<template>
  <div v-show="showCakeNoti" id="cake-noti" style="cursor: pointer" @click="onClick()">
    <div id="cake-noti-container" style="position: absolute; top: 0; right: 0;">
      <i v-show="showCakeNoti" class="sp-ic-sm-modal-close sp-ic-sm-modal-close-14x14" style="position: absolute; top: 15px; right: 18px; cursor: pointer;" @click.stop.prevent="hideCakeNoti()" />
    </div>
    <p v-if="isShowingAmount" id="cake-noti-counter" style="position: absolute; top: 40px; right: 55px; color: white; font-size: 30pt; font-weight: bold;">+{{ amount }}</p>
    <p v-if="isShowingInfo" id="cake-noti-info" style="position: absolute; top: 250px; right: 11px; color: white; font-size: 10pt; width: 280px; text-align: center; background: #1D1F2C; padding-bottom: 10px;">{{ info }}</p>
  </div>
</template>

<script>
import { component } from '../../../mixins/component';
import { NotificationMixin } from '../../../mixins/notification';
import Vue from 'vue';

export default {
  mixins: [component, NotificationMixin],
  props: {
    amount: {
      type: Number,
      default: 0,
    },
    notification: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      info: '',
      cakeNotiAnimation: null,
      isShowingAmount: false,
      isShowingInfo: false,
      showCakeNoti: false,
    };
  },
  watch: {
    notification: function(newVal, oldVal) {
      if (newVal) {
        Vue.nextTick(() => {
          this.init();
        });
      }
    },
  },
  mounted() {
    this.initAnimation();
  },
  methods: {
    init() {
      const action = this.notification.split('#');
      const eventTitle = action[4];

      this.info = this.getAnimationTextUserReward(action[0]);
      this.info = this.info.replace('__COUNT__', this.amount > 1 ? `${this.amount} Mega Cakes` : 'a Mega Cake');
      this.info = this.info.replace('__NAME__', eventTitle);
    },
    initAnimation() {
      this.showCakeNoti = false;
      const urlSpriteSheet = this.contentCloudFront('/assets/spritesheet');
      // eslint-disable-next-line no-undef
      this.cakeNotiAnimation = createSpriteAnimation({
        pngPath: `${urlSpriteSheet}/notificationcake-v1.0.png`,
        jsonPath: `${urlSpriteSheet}/notificationcake-v1.0.json`,
        frameRate: 35,
        id: 'notificationcake',
        containerId: 'cake-noti-container',
        autoPlay: false,
      });
      this.cakeNotiAnimation.boundingBox = { w: 300, h: 350 };
    },
    onClick() {
      const currentLink = window.location.href;
      if (!currentLink.includes(this.routeDropsPage())) {
        window.location.href = this.routeDropsPage();
      }
    },
    playAnimation(callback) {
      this.isShowingAmount = false;
      this.isShowingInfo = false;
      this.showCakeNoti = true;
      // eslint-disable-next-line no-undef
      const animationQueue = new SpriteAnimationQueue(this.cakeNotiAnimation, () => {
        this.isShowingAmount = false;
        this.isShowingInfo = false;
        this.showCakeNoti = false;
        if (callback) {
          callback();
        }
      });
      animationQueue.push(0, 16, () => {
        this.isShowingAmount = true;
        this.isShowingInfo = true;
      });
      animationQueue.push(16, 100);
      /**
                 * Loop to add extra delay
                 */
      // animationQueue.push(40, 100);
      // animationQueue.push(40, 100);
      // animationQueue.push(40, 100);
      // animationQueue.push(40, 100);
      // animationQueue.push(40, 100);

      animationQueue.push(40, 118, () => {
        this.isShowingAmount = false;
        this.isShowingInfo = false;
      });
      animationQueue.push(118);
      animationQueue.play();
    },
    hideCakeNoti() {
      this.showCakeNoti = false;
    },
  },
};
</script>
